import { render, staticRenderFns } from "./RsaConfigurazioneAttivitaResidenzialeListPage.vue?vue&type=template&id=0e57414a"
import script from "./RsaConfigurazioneAttivitaResidenzialeListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAttivitaResidenzialeListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports